export default __webpack_public_path__ + "static/media/amazon-s3.6f28cab3.svg";